import React from 'react';

import { Layout, SectionFour, SectionOne, SectionThree, SectionTwo } from '@components';
import { useScrollbarWidth } from '@utils/hooks/useScrollbarWidth';

const App = () => {
  useScrollbarWidth();

  return (
    <Layout>
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
    </Layout>
  );
};

export default App;
